<template>
  <div class="tab-container">
    Tips
  </div>
</template>

<script >
export default {
  name: 'ClimbingGroupsCrewDetailTips',
}
</script>

